import MessageBubble from './MessageBubble';
import MessageSlim from './MessageSlim';
import MessageWide from './MessageWide';

// Presentation only. Local execution can share the user's chat layout without
// mounting Message's cloud conversation controller or its mutation handlers.
const layouts = { bubble: MessageBubble, slim: MessageSlim, wide: MessageWide };
export function getMessageLayoutComponent(layout) {
  return Object.prototype.hasOwnProperty.call(layouts, layout) ? layouts[layout] : MessageBubble;
}
